import { CanonicalBusinessEvent, CBERecord } from "../types/cbes";

export const sortCbeRecords = (
  cbeObj: CanonicalBusinessEvent
): CanonicalBusinessEvent => {
  const sortedCbe = { ...cbeObj };

  if (sortedCbe.records && Array.isArray(sortedCbe.records)) {
    sortedCbe.records.sort((a: CBERecord, b: CBERecord) => {
      // 1) entryType (CREDIT vs DEBIT)
      const entryTypeA = a.content?.entryType || a.entryType;
      const entryTypeB = b.content?.entryType || b.entryType;
      if (entryTypeA !== entryTypeB) {
        return entryTypeA === "CREDIT" ? -1 : 1;
      }

      // 2) flareConfigFinancialComponent
      const aComponent =
        a.flareConfigFinancialComponent || a.content?.financialComponent || "";
      const bComponent =
        b.flareConfigFinancialComponent || b.content?.financialComponent || "";
      if (aComponent !== bComponent) {
        return aComponent.localeCompare(bComponent);
      }

      // 3) flareConfigFinancialComponentGroup
      const aGroup =
        a.flareConfigFinancialComponentGroup ||
        a.content?.financialComponentGroup ||
        "";
      const bGroup =
        b.flareConfigFinancialComponentGroup ||
        b.content?.financialComponentGroup ||
        "";
      if (aGroup !== bGroup) {
        return aGroup.localeCompare(bGroup);
      }

      // 4) functionalAmount value
      const aAmount = parseFloat(
        a.content?.functionalAmount?.value || a.functionalAmount?.value || "0"
      );
      const bAmount = parseFloat(
        b.content?.functionalAmount?.value || b.functionalAmount?.value || "0"
      );
      if (aAmount !== bAmount) {
        return aAmount - bAmount;
      }

      // 5) tax_jurisdiction_name (if present)
      const aTaxJurisdiction =
        a.content?.taxJurisdictionName ||
        a.content?.clientAttributes?.tax_jurisdiction_name?.stringValue ||
        "";
      const bTaxJurisdiction =
        b.content?.taxJurisdictionName ||
        b.content?.clientAttributes?.tax_jurisdiction_name?.stringValue ||
        "";

      return aTaxJurisdiction.localeCompare(bTaxJurisdiction);
    });
  }

  return sortedCbe;
};

export function isNoOpCBE(cbe: CanonicalBusinessEvent): boolean {
  return cbe.idempotenceId.includes("NONE");
}

export function filterNonNoOpCBEs(
  cbes: CanonicalBusinessEvent[]
): CanonicalBusinessEvent[] {
  return cbes.filter((cbe) => !isNoOpCBE(cbe));
}
